import { useState } from 'react';
import { AuditPanel } from './AuditPanel';
import { CehsPanel } from './CehsPanel';
import { IntegrationsPanel } from './IntegrationsPanel';
import { PresetsPanel } from './PresetsPanel';
import { RolesPanel } from './RolesPanel';
import { UsersPanel } from './UsersPanel';
import { useUser } from './user-context';

// Каждый раздел — под-экран cfg_*; показываем только доступные роли.
const TABS = [
  ['integrations', 'Интеграции', 'cfg_integrations'],
  ['roles', 'Права ролей', 'cfg_roles'],
  ['users', 'Пользователи', 'cfg_users'],
  ['presets', 'Пресеты платежей', 'cfg_presets'],
  ['cehs', 'Цеха', 'cfg_cehs'],
  ['audit', 'Журнал аудита', 'cfg_audit'],
] as const;
type Tab = (typeof TABS)[number][0];

export function SettingsScreen() {
  const user = useUser();
  const tabs = TABS.filter(([, , screen]) => user.screens.includes(screen));
  const [tab, setTab] = useState<Tab>(tabs[0]?.[0] ?? 'integrations');

  if (tabs.length === 0)
    return (
      <div className="scr">
        <div className="scr-head">
          <h2>Настройки</h2>
        </div>
        <p className="muted">Нет доступных разделов настроек.</p>
      </div>
    );

  // Если выбранная вкладка стала недоступной — откатываемся на первую доступную.
  const active = tabs.some(([k]) => k === tab) ? tab : tabs[0][0];

  return (
    <div className="scr">
      <div className="scr-head">
        <h2>Настройки</h2>
        <span className="muted">{tabs.map(([, name]) => name.toLowerCase()).join(' · ')}</span>
      </div>

      <div className="mtabs" style={{ marginBottom: 16 }}>
        {tabs.map(([k, name]) => (
          <button
            key={k}
            className={'mtab' + (active === k ? ' on' : '')}
            onClick={() => setTab(k)}
          >
            {name}
          </button>
        ))}
      </div>

      {active === 'integrations' && <IntegrationsPanel />}
      {active === 'roles' && <RolesPanel />}
      {active === 'users' && <UsersPanel />}
      {active === 'presets' && <PresetsPanel />}
      {active === 'cehs' && <CehsPanel />}
      {active === 'audit' && <AuditPanel />}
    </div>
  );
}
